import { useEffect } from 'react';
import DOMPurify from 'dompurify';
import styles from './ZYcurtain.module.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ZYcurtain = ({
  content,
  className,
  type,
  textAlign,
  end,
  media = 'image',
}) => {
  useEffect(() => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: `.${styles.ctn}`,
        pin: true,
        start: 'top top',
        end: end,
        scrub: true,
        pinSpacing: type === 'move-in' ? false : true,
      },
    });

    content.forEach((item, index) => {
      tl.to(document.querySelectorAll(`.${styles.effectBox}`)[index], {
        height: 0,
      });

      console.log(document.querySelectorAll(`.${styles.effectBox}`)[index]);
    });
  });
  return (
    <div className={`${styles.ctn} ${className}`}>
      {content.map((item, index) => {
        return (
          <div
            className={styles.effectBox}
            style={{
              zIndex: content.length - index,
              position: type === 'move-in' ? 'unset' : 'absolute',
            }}
            key={index}
          >
            <div className={styles.box}>
              {typeof item.text === 'string' ? (
                <div
                  className={`${styles.text} zy-curtain-p`}
                  style={{
                    textAlign: textAlign,
                  }}
                >
                  <div
                    className="zy-curtain-h"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.text),
                    }}
                  ></div>
                </div>
              ) : (
                <div
                  className={styles.text}
                  style={{
                    textAlign: textAlign,
                  }}
                >
                  <div
                    className="zy-curtain-h"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.text.h),
                    }}
                  ></div>
                  <h5
                    className="zy-curtain-p"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.text.p),
                    }}
                  ></h5>
                </div>
              )}

              {media === 'image' ? (
                <img
                  autoPlay
                  loop
                  playsInline
                  muted
                  className={styles.media}
                  src={item.src}
                  alt=""
                />
              ) : (
                <video
                  autoPlay
                  loop
                  playsInline
                  muted
                  className={styles.media}
                  src={item.src}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ZYcurtain;
